export const inventoryData = [
  {
    name: "Hello World Hat",
    price: 23.99,
    img: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/hello-world-hat.jpg",
  },
  {
    name: "Learn From Home Joggers",
    price: 45.99,
    img: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/sweatpants.jpg",
  },
  {
    name: "Java Tee",
    price: 17.99,
    img: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg",
  },
  {
    name: "Python Tee",
    price: 17.99,
    img: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/python-tee.jpg",
  },
  {
    name: "SQL Tee",
    price: 17.99,
    img: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/sql-tee.jpg",
  },
  {
    name: "Hello World Hoodie",
    price: 49.99,
    img: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/hoodie.jpg",
  },
];

export const currenciesData = ["USD", "EUR", "CAD"];
